import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { usePayAllEarnings } from "../../../apis";
import { PayAllEarningsModalProps } from "./PayAllEarningsModal.types";

import styles from "./PayAllEarningsModal.module.scss";

const PayEarningsModal = ({ isOpen, onClose }: PayAllEarningsModalProps) => {
  const { t } = useTranslation();

  const payAllEarnings = usePayAllEarnings({
    onSuccess: () => {
      toast.success(t("All available to pay earnings paid successfully"));
      onClose?.();
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      title={t("Pay All Earnings")}
      okText="Confirm"
      isLoading={payAllEarnings.isLoading}
      onOk={() => payAllEarnings.mutate({})}
      contentClassName={styles.payAllEarningsModal}
      onClose={onClose}
    >
      <p className={styles.payAllEarningsModal_text}>
        {t("Are you sure you want to pay all available to pay earnings?")}
      </p>
    </Modal>
  );
};

export default PayEarningsModal;
